document.addEventListener("DOMContentLoaded", () => {
    document.querySelectorAll(".flex-layout.verhalen_grid-layout").forEach((layout) => {
        const tiles = layout.querySelector(".tiles");
        const nav = layout.querySelector(".pagination-col");
        const filters = [...layout.querySelectorAll(".filter-button")];
        if (!tiles || !layout.dataset.ajaxUrl) return;

        let filter = "all";
        let request = null;

        const load = async (page, { scroll = false } = {}) => {
            request?.abort();
            request = new AbortController();
            tiles.setAttribute("aria-busy", "true");
            layout.classList.add("is-loading");

            const body = new URLSearchParams({
                action: "bz_verhalen_grid",
                post_id: layout.dataset.postId,
                selector: layout.dataset.selector,
                row: layout.dataset.row,
                layout: layout.dataset.layout,
                filter,
                page: String(page),
            });

            try {
                const response = await fetch(layout.dataset.ajaxUrl, { method: "POST", body, signal: request.signal });
                const json = await response.json();
                if (!json.success) throw new Error("verhalen_grid");

                tiles.innerHTML = json.data.html;
                if (nav) {
                    nav.innerHTML = json.data.pagination;
                    nav.hidden = json.data.pages < 2;
                }

                if (scroll) {
                    const reduced = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
                    layout.scrollIntoView({ behavior: reduced ? "auto" : "smooth", block: "start" });
                    tiles.querySelector(".story-tile")?.focus({ preventScroll: true });
                }
            } catch (error) {
                if (error.name !== "AbortError") console.error(error);
            } finally {
                tiles.setAttribute("aria-busy", "false");
                layout.classList.remove("is-loading");
            }
        };

        filters.forEach((button) => {
            button.addEventListener("click", () => {
                if (button.dataset.filter === filter) return;
                filter = button.dataset.filter;
                filters.forEach((other) => {
                    const active = other === button;
                    other.classList.toggle("is-active", active);
                    other.setAttribute("aria-pressed", String(active));
                });
                load(1);
            });
        });

        nav?.addEventListener("click", (event) => {
            const button = event.target.closest("button[data-page]");
            if (!button || button.disabled || button.classList.contains("is-active")) return;
            load(Number(button.dataset.page), { scroll: true });
        });
    });
});
